import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { DocumentiApi, GetDocumentiRequest, InsertDocumentoRequest, UpdateDocumentoRequest, DeleteDocumentoRequest, GetDocumentiByTipoRequest } from '../data/apis/DocumentiApi';


export function DocumentiAccasamentiDataSource(idFiliera: number, idCiclo: number) {
    const documentiApi = new DocumentiApi(apiConfiguration);

    return new CustomStore({
        key: "id",
        load: (loadOptions) => {
            return documentiApi.getDocumentiAccasamenti({
                idFiliera: idFiliera,
                idCiclo: idCiclo
            });
        },

        byKey: (key) => {
            return documentiApi.getDocumentoAccasamentoById({
                idFiliera: idFiliera,
                idCiclo: idCiclo,
                idDocumento: key
            });
        },

        insert: (values) => {
            return documentiApi.insertDocumentoAccasamento({
                idCiclo: idCiclo,
                idFiliera: idFiliera,
                documentoAccasamentoCreateDTO: values
            });
        },

        update: (key, values) => {
            return documentiApi.updateDocumentoAccasamento({
                idFiliera: idFiliera,
                idCiclo: idCiclo,
                idDocumento: key,
                documentoAccasamentoUpdateDTO: values
            });
        },

        remove: (key) => {
            return documentiApi.deleteDocumentoAccasamento({
                idFiliera: idFiliera,
                idCiclo: idCiclo,
                idDocumento: key
            });
        }
    });
};

